
import React from 'react'
import {Router, Route, hashHistory, Redirect} from 'react-router'
import {Provider} from 'react-redux'
import {IntlProvider} from 'react-intl'

import Search from './components/Search'
import PreSearch from './components/PreSearch'

import store from './store'

import updateSuggestions from './actions/updateSuggestions'
import loadControlTables from './actions/loadControlTables'
import restoreSession from './actions/restoreSession'
import saveCompletedTours from './actions/saveCompletedTours'

import getLocaleFromUrl from './utils/getLocaleFromUrl'
import {fromQueryObject} from './utils/queryObjectMapper'

const locale = getLocaleFromUrl()
const dispatchRouteChange = (location) => {
  if(getLocaleFromUrl() !== locale){
    window.location.reload()
  }
}

//TODO `unsubscribeFromHistory` function should be called when the app is reloaded
const unsubscribeFromHistory = hashHistory.listen(dispatchRouteChange)

const doUpdateSuggestions = _ => store.dispatch(updateSuggestions())
store.dispatch(loadControlTables())

const getCookie = (cname) => {
     let name = cname + "=";
     let ca = document.cookie.split(';');
     for(let i = 0; i <ca.length; i++) {
       let c = ca[i];
       while (c.charAt(0)==' ') {
         c = c.substring(1);
       }
       if (c.indexOf(name) == 0) {
         return c.substring(name.length,c.length);
       }
     }
     return null;
}

const userName = getCookie('username');
const token = getCookie('X-authorization');

store.dispatch(restoreSession(userName, token))

const completedTours = {
  preSearch: localStorage.getItem('pre-search-tour-completed') ==  "true",
  search: localStorage.getItem('search-tour-completed') == "true"
}
store.dispatch(saveCompletedTours(completedTours))

const RoutedApp = _ =>
  <Router history={hashHistory}>
    <Route path="/:locale/pre-search" component={PreSearch} onEnter={doUpdateSuggestions}/>
    <Route path="/:locale/search" component={Search}  onEnter={doUpdateSuggestions}/>
    <Redirect from="/*" to="/fr/search"/>
  </Router>

const App = (props) =>
  <IntlProvider {...props}>
    <Provider store={store}>
      <RoutedApp/>
    </Provider>
  </IntlProvider>

export default App



/** WEBPACK FOOTER **
 ** ./app/App.jsx
 **/